import React from 'react'
import './PageNotFound.css';
import pageNotFoundImage from '../../assets/images/PageNotFound.png';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowLeft} from '@fortawesome/free-solid-svg-icons'
import {NavLink} from 'react-router-dom'
const PageNotFound = () => {
  return (
    <>
    <div className="sections pageNotFound-section">
        <img src={pageNotFoundImage} alt="Page Not Found" loading='lazy'/>
        <NavLink to={'/'}>
        <div className='go-back'><FontAwesomeIcon icon={faArrowLeft} size='1x' beatFade/>Go Back</div>
        </NavLink>
    </div>
    </>
  )
}

export default PageNotFound